import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/common";

const ClientDashboard = lazy(() =>
  import("../pages/client").then((m) => ({ default: m.ClientDashboard }))
);

function ChunkLoader() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

const ClientRoutes = () => {
  return (
    <>
      <Route
        path="client/dashboard"
        element={
          <ProtectedRoute requiredRole="client">
            <Suspense fallback={<ChunkLoader />}>
              <ClientDashboard />
            </Suspense>
          </ProtectedRoute>
        }
      />
    </>
  );
};

export default ClientRoutes;
